const CHUNK_LOAD_RECOVERY_KEY = 'aspis_chunk_recovery_attempted';

const CHUNK_ERROR_PATTERNS = [
  /Failed to fetch dynamically imported module/i,
  /Loading chunk [\w-]+ failed/i,
  /Expected a JavaScript-or-Wasm module script/i,
  /dynamically imported module/i,
  /mime type/i,
];

function getErrorMessage(input: unknown): string {
  if (!input) return '';
  if (typeof input === 'string') return input;
  if (input instanceof Error) return input.message || '';
  try {
    return JSON.stringify(input);
  } catch {
    return String(input);
  }
}

export function isRecoverableChunkLoadError(input: unknown): boolean {
  const message = getErrorMessage(input);
  return CHUNK_ERROR_PATTERNS.some((pattern) => pattern.test(message));
}

export async function recoverFromChunkLoadError(): Promise<boolean> {
  if (typeof window === 'undefined') return false;

  const attempted = window.sessionStorage.getItem(CHUNK_LOAD_RECOVERY_KEY) === '1';
  if (attempted) return false;

  window.sessionStorage.setItem(CHUNK_LOAD_RECOVERY_KEY, '1');

  try {
    if ('serviceWorker' in navigator) {
      const regs = await navigator.serviceWorker.getRegistrations();
      await Promise.all(regs.map((reg) => reg.unregister()));
    }

    if ('caches' in window) {
      const keys = await caches.keys();
      await Promise.all(keys.map((key) => caches.delete(key)));
    }
  } catch (error) {
    console.warn('Chunk recovery cache reset failed', error);
  }

  const url = new URL(window.location.href);
  url.searchParams.set('recovered', String(Date.now()));
  window.location.replace(url.toString());
  return true;
}
